import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useHistory } from "react-router";
import TabPanel, { Item } from "devextreme-react/tab-panel";
import { Popup, Position, ToolbarItem } from 'devextreme-react/popup';
import { Switch, Button } from 'devextreme-react';
import Form, { SimpleItem, Label } from 'devextreme-react/form';
import { Item as AssetTabItem } from 'devextreme-react/form';
import { useLocation } from 'react-router-dom';
import TenantService from "api/tenant.service";
import AssetsService from "api/assets.service";
import { LoadPanel as LoadingPanel } from 'devextreme-react/load-panel';
import Toast from 'components/Toast';
import AssetView from "./asset.js"
// import EventView from "./events.js"
import UtilizationHeatMap from "./utilizationHeatMap";
import MechanicalHeatMap from "./mechanicalHeatMap";
import moment from 'moment-timezone';
import './assetTab.css'
import { ButtonItem } from "devextreme-react/form";
import { DateBox, NumberBox, TextBox } from "devextreme-react";

export default function App(props) {
    const tabPanelRef = useRef(null);
    // const location = useLocation();
    // const selectedIndexFromUrl = location.state ? location.state.selectedIndex : 0;
    const form = useRef(null);
    const assetId = props.match.params.assetId;
    const tenant = TenantService.getTenant();
    const [fields, setFields] = useState([]);
    const [fieldData, setFieldData] = useState();
    const [attributes, setAttributes] = useState([])
    const [fieldDataOG, setFieldDataOG] = useState();
    const [checkBoxValue, setCheckBoxValue] = useState(false);
    const [types, setTypes] = useState([]);
    const [deviceType, setDeviceType] = useState(null);
    const [assetType, setAssetType] = useState(null);
    const [devices, setDevices] = useState([]);
    const [pageName, setPageName] = useState("");
    const [editAllowed, setEditAllowed] = useState(false);
    const [saveChangedOG, setSaveChangedOG] = useState([]);
    const [saveChanged, setSaveChanged] = useState([]);
    const [popupVisible, setPopupVisible] = useState(false);
    const [editedFlag, setEditedFlag] = useState(false);
    const [spaces, setSpaces] = useState([]);
    const [dateRange, setDateRange] = useState([]);
    const [lastPositionUpdateTime, setLastPositionUpdateTime] = useState("");
    const [latestDwellTime, setLatestDwellTime] = useState("");
    const [selectedTabIndex, setSelectedTabIndex] = useState(0);
    const MECHANICAL_DEVICE_TYPE_ID = 12
    const PE_MACHINE_ASSET_TYPE = '371ba9a2-2f39-46ec-8244-413737303a6b';
    const DEMO_TENANT_ID = 'c5a9b628-49ae-4f7c-9e5a-8909c07c47bb';
    const PE_TENANT_ID = '964f8b8d-14a6-40f9-9b6f-c7614e1238a0';
    const MRP_SOLUTIONS_TENANT_ID = '0fcc4e26-8d5c-409c-a60c-a4a87c20d416';
    const MOLDFORM_TENANT_ID = '468c693b-f62b-40a5-a536-e41dbef902ed';
    const KABOOM_LABS_ID = 'f51ff9cb-5b92-4730-8844-159f1df4ee6f';
    const MOLDFORMINGDEMO_BENOIT_TENANT_ID = '3ecae8b8-3221-431e-b4f1-44009de1619e';
    const MOLDFORMINGDEMO_JOSE_TENANT_ID = 'ec00faad-2740-4ca1-be9c-8d83680b402c';
    const REDLORE_TENANT_ID = '19e7c189-4b94-46dd-939b-bc5236c4800b';
    const telemetryVisible = (
        tenant === MRP_SOLUTIONS_TENANT_ID ||
        tenant === MOLDFORM_TENANT_ID ||
        tenant === KABOOM_LABS_ID ||
        tenant === MOLDFORMINGDEMO_BENOIT_TENANT_ID ||
        tenant === MOLDFORMINGDEMO_JOSE_TENANT_ID ||
        tenant === REDLORE_TENANT_ID
    )

    const [loading, setLoading] = useState(false);
    const [toastConfig, setToastConfig] = React.useState({
        isVisible: false,
        type: 'info',
        message: '',
        displayTime: 5000,
    });
    const [isPopupVisible, setisPopupVisible] = useState(false)
    const history = useHistory();
    //perkin elmor demo changes
    const [daysToMaintenance, setDaysToMaintenance] = useState(0);
    const [maintenanceStatus, setMaintenanceStatus] = useState("Never Maintained");


    const acceptOptions = {
        text: 'Yes',
        onClick: function (e) {
            manageBtn(true, false)
        }
    };
    const rejectOptions = {
        text: 'No',
        onClick: function (e) {
            manageBtn(false, false)
        }
    };

    function manageBtn(isNotifiedVal, isPopupVisibleVal) {
        wakeUpBtn(isNotifiedVal)
        setisPopupVisible(isPopupVisibleVal)
        setTimeout(() => {
            history.push('/assets')
        }, 1000);
    }

    function checkRole() {
        var role = JSON.parse(localStorage.getItem("role"));
        let canEdit = false
        for (let i = 0; i < role.length; i++) {
            if (role[i].name === "Asset Attributes") {
                if (role[i].write === true) {
                    canEdit = true
                }
            }
        }
        if (canEdit) {
            setEditAllowed(true)
        }
    }

    const renderContent = () => {
        return (
            <>Do you want to receive a notification when the device is ready for retrieval?</>
        );
    };

    function showPopup() {
        setisPopupVisible(true)
    }

    function hidePopup() {
        setisPopupVisible(false)
    }

    function getData() {
        AssetsService.getAsset(assetId).then((value) => {
            let data = value.data.data
            setPageName(data.name)
            if (data.info !== null) {
                setCheckBoxValue(data.info.checkInState.value)
            }
            if (data.info !== null) {
                setCheckBoxValue(data.info.checkInState.value)
            }
            if (data.lastKnownLocation && data.lastKnownLocation.timestamp) {
                setLastPositionUpdateTime(moment(data.lastKnownLocation.timestamp).format("YYYY-MM-DD HH:mm"))
                handleDwellTime(data?.dwellStart)
            } else {
                setLastPositionUpdateTime("None")
                setLatestDwellTime("None")
            }
            if (tenant === PE_TENANT_ID) {
                const allowedKeys = ["last_maintenance_date", "maintenance_period"];
                const extractedKeys = Object.keys(data.attributes).filter(key => allowedKeys.includes(key));
                setAttributes(extractedKeys);
                setDaysToMaintenance(data.daysToMaintenance)
                setMaintenanceStatus(data.maintenanceStatus)
            }

            // if (tenant === PE_TENANT_ID){
            //     const allowedKeys = ["last_maintenance_date", "maintenance_period"];
            //     const extractedKeys = Object.keys(data.attributes).filter(key => allowedKeys.includes(key));
            //     setAttributes(extractedKeys);
            //     if (data?.attributes?.last_maintenance_date){
            //         debugger
            //         const [month, day, year] = data.attributes.last_maintenance_date.split("/"); // Ensure it's MM/DD/YYYY
            //         const parsedDate = new Date(Number(year), Number(month) - 1, Number(day)); // Month is 0-based in JS
            //         console.log('PArSED DATE: ', parsedDate);

            //         setLastMaintenanceDate(parsedDate);

            //         setMaintenancePeriod(parseInt(data?.attributes?.maintenance_period))
            //         // setTimeout(() => {
            //         //     calculateMaintenanceStatus();
            //         // }, 5000);

            //     }
            // }

            setFieldData(data.attributes)
            setFieldDataOG(data)
            setDeviceType(data.pairedDevice.deviceType)
            setAssetType(data.type.id)

            let currentDeviceSerial = data.pairedDevice.serialNumber
            AssetsService.getAssetTagsToPair(tenant).then((value) => {
                let response = value.data
                let serials = []
                let serialsId = []
                serials.push({
                    "serialNumber": "Unpaired",
                    "id": null
                })
                serialsId.push(null)
                for (let i = 0; i < response.data.length; i++) {
                    if (response.data[i].freeToPair || response.data[i].serialNumber === currentDeviceSerial) {
                        serials.push({
                            "serialNumber": response.data[i].serialNumber,
                            "id": response.data[i].id
                        })
                        serialsId.push(response.data[i].id)
                    }
                }
                setDevices(serials)
            })
        })
    }

    function getDetailedDifference(startDate, endDate) {
        const start = moment(startDate);
        const end = moment(endDate);

        let days = end.diff(start, 'days');
        start.add(days, 'days');

        let hours = end.diff(start, 'hours');
        start.add(hours, 'hours');

        let minutes = end.diff(start, 'minutes');

        let diffString = '';

        if (days > 0) {
            diffString += `${days} days`;
        }

        if (hours > 0) {
            if (diffString) diffString += ', ';
            if (hours > 1) diffString += `${hours} hours`;
            else diffString += `${hours} hour`;
        }

        if (minutes > 0) {
            if (diffString) diffString += ' and ';
            diffString += `${minutes} minutes`;
        }

        return diffString || '0 minutes';
    }


    function getTypes() {
        AssetsService.getAssetTenantTypes(tenant).then((value) => {
            let response = value.data
            setTypes(response.data)
        })
    }

    const wakeUpBtn = (isNotification) => {
        AssetsService.sendCommand(assetId, "WAKEUP", isNotification, isNotification).then((response) => {
            setToastConfig({
                ...toastConfig,
                isVisible: true,
                type: response.status === 200 ? 'success' : 'error',
                status: response?.data?.status ? response.data.status : response?.status,
                message: response?.data?.message ? response.data.message : response?.message,
            });
        })
    }

    function beepBtn() {
        AssetsService.sendCommand(assetId, "RETRIEVE").then(async (response) => {
            if (response.status === 200) {
                await setToastConfig({
                    ...toastConfig,
                    isVisible: true,
                    type: response.status === 200 ? 'success' : 'error',
                    status: response?.data?.status ? response.data.status : response?.status,
                    message: response?.data?.message ? response.data.message : response?.message,
                });
            } else {
                await setToastConfig({
                    ...toastConfig,
                    isVisible: true,
                    type: 'error',
                    status: 400,
                    message: 'Cannot retrieve asset because no device paired to asset.',
                });
            }
        }).catch((err) => {
            console.error('Error:', err);
            setToastConfig({
                ...toastConfig,
                isVisible: true,
                type: 'error',
                status: 400,
                message: 'Cannot retrieve asset because no device paired to asset.',
            });
        })
    }

    const onValueChanged = useCallback(async (event) => {
        await setCheckBoxValue(!checkBoxValue);
        await AssetsService.sendCommand(assetId, "CHECKIN", !checkBoxValue, !checkBoxValue).then((response) => {
            setToastConfig({
                ...toastConfig,
                isVisible: true,
                type: response.status === 200 ? 'success' : 'error',
                status: response?.data?.status ? response.data.status : response?.status,
                message: response?.data?.message ? response.data.message : response?.message,
            });
            if (response.status === 200) setCheckBoxValue(!checkBoxValue);
        })
    }, [checkBoxValue]);

    function getTypeAttributes(typeId) {
        AssetsService.getAssetTypeAttributes(typeId).then((value) => {
            let response = value.data
            setFields(response.data)
            setFieldData([])
        })
    }

    function editAsset(key, value) {
        console.log('SELECTED TAB INDEX: ', selectedTabIndex);
        console.log('KEY', key);
        console.log('KEY', value);
        setLoading(true)
        let id = assetId
        let name
        let typeId
        let pairedDevice
        let attributes
        if (key === "name") {
            name = value
        } else if (key === "type.id") {
            typeId = value
            getTypeAttributes(typeId)
        } else if (key === "pairedDevice.id") {
            pairedDevice = value
        } else {
            var dynamicKey = key;
            let payload = {}
            payload[dynamicKey] = value
            attributes = payload
        }
        AssetsService.editAsset(id, name, typeId, pairedDevice, attributes).then((value) => {
            setLoading(false)
            if (value.status === 200) {
                setToastConfig({
                    ...toastConfig,
                    isVisible: true,
                    type: 'success',
                    message: "Edit successful",
                    status: 200,
                });
                if (selectedTabIndex === 5 && tenant === PE_TENANT_ID) {
                    setDaysToMaintenance(value.data.data.daysToMaintenance)
                    setMaintenanceStatus(value.data.data.maintenanceStatus)
                    getData()
                }
            } else {
                setToastConfig({
                    ...toastConfig,
                    isVisible: true,
                    type: 'error',
                    message: "Edit unsuccessful",
                    status: 500,
                });
            }
        })
    }

    function onFieldDataChanged(e) {
        let existingData = saveChanged
        let didExist = false
        for (let i = 0; i < existingData.length; i++) {
            if (existingData[i].key === e.dataField) {
                existingData[i].value = e.value
                didExist = true
            }
        }
        if (!didExist) {
            existingData.push({
                "key": e.dataField,
                "value": e.value
            })
            setSaveChanged(existingData)
        } else {
            setSaveChanged(existingData)
        }
        setEditedFlag(true)
    }

    function onFieldDataChangedOG(e) {
        let existingDataOG = saveChangedOG
        let didExist = false
        for (let i = 0; i < existingDataOG.length; i++) {
            if (existingDataOG[i].key === e.dataField) {
                existingDataOG[i].value = e.value
                didExist = true
            }
        }
        if (!didExist) {
            existingDataOG.push({
                "key": e.dataField,
                "value": e.value
            })
            setSaveChanged(existingDataOG)
        } else {
            setSaveChangedOG(existingDataOG)
        }
        setEditedFlag(true)
    }

    function onClick(type) {
        for (let i = 0; i < saveChangedOG.length; i++) {
            editAsset(saveChangedOG[i].key, saveChangedOG[i].value)
        }
        for (let i = 0; i < saveChanged.length; i++) {
            editAsset(saveChanged[i].key, saveChanged[i].value)
        }
        setEditedFlag(false)
    }

    const typeEditorOptions = {
        dataSource: types,
        searchEnabled: true,
        displayExpr: "name",
        valueExpr: "id",
    };

    const deviceEditorOptions = {
        dataSource: devices,
        searchEnabled: true,
        displayExpr: "serialNumber",
        valueExpr: "id"
    };

    function handleDwellTime(startTime) {
        console.log('Start time handle: ', startTime);
        if (startTime) {
            const now = moment().format('YYYY-MM-DD HH:mm:ss');
            const diff = getDetailedDifference(startTime, now)
            setLatestDwellTime(diff)
        } else {
            setLatestDwellTime("Not available")
        }
    }

    function goBack() {
        history.push({
            pathname: `/assets/`,
            state: {
                response: ""
            }
        })
    }

    function saveGoBack() {
        onClick()
        history.push({
            pathname: `/assets/`,
            state: {
                response: ""
            }
        })
    }

    useEffect(() => {
        getData()
        getTypes()
        checkRole()

        // Restore previously selected tab for MRP Solutions tenant if it was Telemetry
        if (telemetryVisible) {
            const savedTabIndex = localStorage.getItem(`assetTab_${assetId}_${tenant}`);
            if (savedTabIndex && parseInt(savedTabIndex) === 5) { // 5 is Telemetry tab index
                setSelectedTabIndex(5);
            }
        }
    }, []);

    useEffect(() => {
    }, [types]);


    function hideInfo() {
        setPopupVisible(false)
    }

    function onSave() {
        if (editedFlag) {
            setPopupVisible(true)
        } else {
            goBack()
        }
    }

    function getFormattedDate() {
        const today = new Date();
        const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const dd = String(today.getDate()).padStart(2, '0');
        const yyyy = today.getFullYear();

        return `${mm}/${dd}/${yyyy}`;
    }

    // Reset Maintenance Date to Today
    const resetMaintenanceDate = () => {
        editAsset("last_maintenance_date", getFormattedDate())
    };

    return (
        <>
            <Popup
                visible={popupVisible}
                onHiding={hideInfo}
                dragEnabled={false}
                closeOnOutsideClick={true}
                showCloseButton={false}
                showTitle={false}
                title={"Do you wish to save the changes? "}
                container=".dx-viewport"
                height={"120px"}
                width={"270px"}
            >
                <Position
                    at="center"
                    my="center"
                />
                <div className='assetTab-saveDiscardTitle'> Do you wish to save the changes? </div>
                <div className='assetTab-saveDiscardContainer'>
                    <div className='assetTab-saveBtn' onClick={saveGoBack}> SAVE </div>
                    <div className='assetTab-saveBtn' onClick={goBack}> DISCARD </div>
                </div>
            </Popup>
            <div className='topBarAssetTab'>
                <div className='titleAsset' >
                    <b>Asset: {pageName}</b> &nbsp;&nbsp;<span style={{ paddingLeft: "12px", fontSize: "14px" }}>Last Position Update: {lastPositionUpdateTime}</span>&nbsp;&nbsp;<span style={{ paddingLeft: "12px", fontSize: "14px" }}>Dwell time in current space: {latestDwellTime}</span>
                </div>
                <div className='backBtn' onClick={onSave}>
                    <i className="dx-icon-close"></i>
                </div>
            </div>
            <TabPanel ref={tabPanelRef}
                swipeEnabled={false}
                selectedIndex={selectedTabIndex}
                onOptionChanged={(e) => {
                    if (e.name === "selectedIndex") {
                        setSelectedTabIndex(e.value);
                        // Save tab selection for MRP Solutions tenant
                        if (telemetryVisible) {
                            localStorage.setItem(`assetTab_${assetId}_${tenant}`, e.value.toString());
                        }
                    }
                }}>
                <Item title="History" >
                    <AssetView
                        assetId={assetId}
                        assetName={pageName}
                        onSpaceLoad={(spaces) => setSpaces(spaces)}
                        onDateChange={(dateRange) => setDateRange(dateRange)}
                        dateRange={dateRange}
                        selectedTabIndex={selectedTabIndex}
                        dwellTime={(dTime) => setLatestDwellTime(dTime)}
                    // dwellTime={handleDwellTime}
                    />
                </Item>
                <Item title="Edit" >
                    <div className='assetForm'>
                        <div className='assetTab-topForm'>
                            <Form
                                onFieldDataChanged={onFieldDataChangedOG}
                                formData={fieldDataOG}
                                labelLocation={"left"}
                                labelMode={"outside"}
                            >
                                <SimpleItem dataField="name" />
                                <AssetTabItem dataField="type.id"
                                    editorType="dxSelectBox" editorOptions={typeEditorOptions}>
                                    <Label text="Type" />
                                </AssetTabItem>
                                <AssetTabItem dataField="pairedDevice.id"
                                    editorType="dxSelectBox" editorOptions={deviceEditorOptions}>
                                    <Label text="Paired Tag" />
                                </AssetTabItem>
                            </Form>
                        </div>
                        <div className='assetTab-bottomForm'>
                            <h2 className='assetTabh2'> Attributes</h2>
                            <Form
                                onFieldDataChanged={onFieldDataChanged}
                                formData={fieldData}
                                ref={form}
                                disabled={!editAllowed}
                                labelLocation={"left"}
                                labelMode={"outside"}
                            >
                                {fields.map((field, i) =>
                                    <SimpleItem
                                        key={i}
                                        dataField={`${field.name}`}
                                    >
                                    </SimpleItem>
                                )}
                            </Form>
                            {/* <div style={{cursor: "pointer"}} className='profile-save' onClick={onClick}>
                                Save
                            </div> */}
                            <div style={{ marginTop: "40px" }}>
                                {/* <Button
                              width={"160px"}
                              type="normal"
                              stylingMode="outlined"
                              onClick={onClick}
                              text="Save"
                            /> */}
                                <div>
                                    <button className='profile-save' onClick={onClick}>SAVE</button>
                                    <button className='profile-save' onClick={goBack}>CANCEL</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Item>
                <Item title="Actions">
                    <div className='assetTab-checkboxContainer'>
                        <div className='assetTab-checkboxText'>
                            Asset Checked &nbsp;  &nbsp; OUT
                        </div>
                        <div className='assetTab-checkbox'>
                            <Switch
                                value={checkBoxValue}
                                onValueChanged={onValueChanged}
                                text={"Asset checked"}
                                iconSize={39}
                                switchedOnText={"On"}
                            />
                        </div>
                        <div className='assetTab-checkboxText'>
                            IN
                        </div>
                    </div>
                    <div className='ActionsPage'>
                        {/* <Button
                            height={41}
                            className={'wakeUpBtn'}
                            text="Text"
                            type="normal"
                            stylingMode="outlined"
                            onClick={() => wakeUpBtn(true)}
                        >
                            Wake Up
                        </Button>

                        <Button
                            height={41}
                            className={'beepBtn'}
                            text="Text"
                            type="normal"
                            stylingMode="outlined"
                            onClick={beepBtn}
                            style={{marginLeft:"10px"}}
                        >
                            Retrieve
                        </Button> */}

                        <div>
                            <button className='profile-save' onClick={() => wakeUpBtn(true)}>WAKE UP</button>
                            <button className='profile-save' onClick={beepBtn}>RETRIEVE</button>
                        </div>

                        <Popup
                            title="Confirm"
                            showTitle={true}
                            visible={isPopupVisible}
                            contentRender={renderContent}
                            onHiding={hidePopup}
                            hideOnOutsideClick={false}
                            showCloseButton={true}
                            width={300}
                            height={"auto"}
                        >
                            <ToolbarItem
                                widget="dxButton"
                                toolbar="bottom"
                                location="before"
                                options={acceptOptions}
                            />
                            <ToolbarItem
                                widget="dxButton"
                                toolbar="bottom"
                                location="after"
                                options={rejectOptions}
                            />
                        </Popup>
                    </div>
                </Item>
                {/* <Item title="Events">
                    <EventView assetId={assetId}>
                    </EventView>
                </Item> */}
                <Item title="Utilization" visible={tenant !== MOLDFORMINGDEMO_BENOIT_TENANT_ID && tenant !== MOLDFORMINGDEMO_JOSE_TENANT_ID && tenant !== REDLORE_TENANT_ID}>
                    <UtilizationHeatMap
                        assetId={assetId}
                        assetName={pageName}
                        spaces={spaces}
                        tenant={tenant}
                        dateRange={dateRange}
                        onDateChange={(dateRange) => setDateRange(dateRange)}
                        selectedTabIndex={selectedTabIndex}
                        assetType={assetType}
                    />
                </Item>
                <Item title="Telemetry" visible={deviceType === MECHANICAL_DEVICE_TYPE_ID && tenant === DEMO_TENANT_ID}>
                    <MechanicalHeatMap
                        assetId={assetId}
                        tenant={tenant}
                        dateRange={dateRange}
                        onDateChange={(dateRange) => setDateRange(dateRange)}
                        assetName={pageName}
                        selectedTabIndex={selectedTabIndex}
                    />
                </Item>
                <Item title="Telemetry" visible={telemetryVisible}>
                    <MechanicalHeatMap
                        assetId={assetId}
                        tenant={tenant}
                        dateRange={dateRange}
                        onDateChange={(dateRange) => setDateRange(dateRange)}
                        assetName={pageName}
                        selectedTabIndex={selectedTabIndex}
                    />
                </Item>

                <Item title="Maintenance" visible={tenant === PE_TENANT_ID && assetType === PE_MACHINE_ASSET_TYPE}>
                    <div className='assetForm'>
                        <div className='assetTab-topForm'>
                            <Form
                                onFieldDataChanged={onFieldDataChanged}
                                formData={fieldData}
                                ref={form}
                                disabled={!editAllowed}
                                labelLocation={"left"}
                                labelMode={"outside"}
                            >
                                {attributes.map((field, i) =>
                                    <SimpleItem
                                        key={i}
                                        dataField={`${field}`}
                                    >
                                    </SimpleItem>
                                )}
                                {/* {attributes.map((field, i) => (
                                    <SimpleItem
                                        key={i}
                                        dataField={`${field}`}
                                        label={field === 'last_maintenance_date' ? { text: 'Last maintenance date [days]' } : undefined}
                                    >
                                    </SimpleItem>
                                ))} */}

                                <AssetTabItem dataField="days_to_maintenance">
                                    <NumberBox value={daysToMaintenance} readOnly />
                                </AssetTabItem>
                                <AssetTabItem dataField="maintenance_status">
                                    <TextBox value={maintenanceStatus} readOnly />
                                </AssetTabItem>
                            </Form>
                        </div>
                        <div className='assetTab-bottomForm'>
                            <div style={{ marginTop: "40px" }}>
                                <div className="button-group">
                                    <button className='profile-save' style={{ whiteSpace: 'nowrap', marginLeft: '0px' }} onClick={resetMaintenanceDate}>RESET MAINTENANCE DATE</button>
                                    <button className='profile-save' style={{ whiteSpace: 'nowrap' }} onClick={() => onClick('maintenance')}>SAVE</button>
                                    <button className='profile-save cancel-save' onClick={goBack}>CANCEL</button>
                                </div>
                            </div>
                        </div>

                    </div>
                </Item>
            </TabPanel>
            <Toast
                setParentToastConfig={setToastConfig}
                toastBody={toastConfig}
            />
            <LoadingPanel
                shadingColor="rgba(0,0,0,0.4)"
                visible={loading}
                showIndicator={true}
                showPane={true}
                shading={true}
                closeOnOutsideClick={false}
            />
        </>
    );
}